import React, { useContext } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { Row, Col } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Image } from '@thd-olt-component-react/core-ui';
import { Heading } from '@thd-olt-component-react/heading';
import { track } from './related-search-analytics';

const PopularCategory = (props) => {
  const {
    relatedLinks,
    title
  } = props;

  const {
    channel
  } = useContext(ExperienceContext);

  const renderRelatedSearch = (relatedSearchResults) => {
    let url = '';

    return (
      <div className="related-search__links">
        {relatedSearchResults.map((relatedSearchResult, index) => {
          url = relatedSearchResult.url || (`/s/${encodeURIComponent(relatedSearchResult.text)}`);
          const copyText = relatedSearchResult.text;

          return (
            <span className="related-search__elements" key={`popcat-${copyText}${index}`}>
              <Image
                src="https://assets.thdstatic.com/images/v1/magnify-tilted-left-grey.svg"
                alt="magnifying glass"
                className="related-search__elements__magnify-symbol"
                height="14"
                width="14"
              />
              <a className="bttn--inline" href={url} onClick={() => track(copyText)}>
                <h3 className="related-search__elements-text">{copyText}</h3>
              </a>
            </span>
          );
        })}
      </div>
    );
  };

  return (
    <Row className="related-search">
      <Col>
        {channel !== 'mobile'
          && (
            <>
              <Heading centered underline title={title} />
              {renderRelatedSearch(relatedLinks)}
            </>
          )}
        {channel === 'mobile'
          && (

            <>
              <Heading underline title={title} />
              {renderRelatedSearch(relatedLinks)}
            </>

          )}
      </Col>
    </Row>
  );
};

export { PopularCategory };

PopularCategory.propTypes = {
  relatedLinks: arrayOf(shape({})).isRequired,
  title: string

};

PopularCategory.defaultProps = {
  title: 'Popular Categories'
};
